import React, { useEffect } from 'react';
import GenericChart from '../GenericChart';
import MultiFeatureCard from '../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import { get } from 'lodash';
import useExpandableGridHelper from '../../../hooks/useExpandableGridHelper';
import {
  checkOnlyDateFormatAndUpdateFormat,
  currentDateFormat,
  DATE_FORMAT_MAPPING
} from '../../../../../utils/transformChartsAndTableData';
import { useDispatch } from 'react-redux';

const ReviewsAndAverageRating = props => {
  const { itemData, timeperiodLabel, applied_filter_values, widgetId, reduxData } = props;
  const dispatch = useDispatch();
  const { fetchData, error, loadingData } = useExpandableGridHelper({
    widgetId,
    appliedFilterValues: applied_filter_values,
    onAggregationResponseFn: ({ rawData, widgetId }) => {
      dispatch({
        type: 'SAVE_WIDGET_CHART_DATA',
        payload: {
          widgetId: widgetId,
          metricType: 'default',
          chartData: rawData,
          currentLevel: 'default'
        }
      });
    }
  });
  const columns = get(reduxData, 'chartData.default.default.data.columns', []);
  const metric_data = get(reduxData, 'chartData.default.default.data.metric_data', []);
  const rows = get(reduxData, 'chartData.default.default.data.rows', []);
  const xAxisCategories = columns.map(col =>
    checkOnlyDateFormatAndUpdateFormat(col, DATE_FORMAT_MAPPING[currentDateFormat(col)])
  );
  const yAxisCategories = [];

  const series = [
    {
      name: 'Average rating',
      type: 'column',
      key: 'Average',
      yAxis: 0,
      color: '#4f5bd5',
      data: metric_data[1]
    },
    {
      name: 'Review count',
      type: 'spline',
      key: '# of Responses',
      yAxis: 1,
      color: '#8ACA90',
      data: metric_data[0]
    }
  ];

  useEffect(() => {
    if (widgetId) fetchData();
  }, [widgetId, fetchData]);
  let ddd = {
    "chart": {
      "zoomType": "x",
      "spacing": [
        50,
        20,
        20,
        20
      ]
    },
    "title": {
      "text": " "
    },
    "xAxis": {
      "labels": {
        "rotation": -90,
        "style": {
          "fontSize": "11px"
        }
      }
    },
    "yAxis": [
      {
        "min": 0,
        "max": 10,
        "title": {
          "text": "Average rating",
          "style": {
            "color": "#6b7280"
          }
        }
      },
      {
        "opposite": true,
        "min": 0,
        "title": {
          "text": "Responses"
        }
      }
    ],
    "tooltip": {
      "shared": true,
      "useHTML": true,
      "followPointer": true,
      "outside": true,
      "backgroundColor": "none",
      "borderWidth": 0,
      "shadow": false
    },
    "plotOptions": {
      "column": {
        "borderRadius": 3,
        // "pointWidth": 10
      },
      "line": {
        "marker": {
          "enabled": true,
          "radius": 5
        }
      }
    },
    "exporting": {
      "enabled": false
    },
    "legend": {
      "enabled": false
    },
    "credits": {
      "enabled": false
    }
  }

  return (
    <MultiFeatureCard
      title={get(itemData, 'title', 'Reviews and Average Rating Over Time')}
      subTitle={timeperiodLabel}
      isNoData={!loadingData && !rows.length}
      style={{ childContainer: { minHeight: 250 } }}
      loading={loadingData}
      renderContent={() => {
        return (
          <>
            {!loadingData && (
              <GenericChart
                // defaultConfig={get(itemData, 'chartDefaultConfig', {})}
                defaultConfig={ddd}
                xAxisCategories={xAxisCategories}
                yAxisCategories={yAxisCategories}
                series={series}
                tooltipValueKeysConfig={{
                  isheaderVisible: true,
                  headerLabelKey: "key",
                  bodyLabelKey: "series.name",
                  bodyValueKey: "y"
                }
                }
              />

            )}
          </>
        );
      }}
    />
  );
};
export default ReviewsAndAverageRating;
